import React, { Component } from 'react';
import { Button } from '../../components';
import PropTypes from 'prop-types';


class GenderSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gender: null,
    };
  }

  changeGender(gender) {
    this.setState({ gender });
    if (this.props.onGenderChanged) {
      this.props.onGenderChanged(gender);
    }
  }

  render() {
    const highlightFemale = this.state.gender == 'female' ? styles.female : styles.default;
    const highlightMale = this.state.gender == 'male' ? styles.male : styles.default;

    return (
      <div style={styles.container}>
        <Button
          labelStyle={highlightMale}
          style={styles.button}
          onClick={this.changeGender.bind(this, 'male')}
          label={'Männlich'}
        />
        <Button
          labelStyle={highlightFemale}
          style={styles.button}
          onClick={this.changeGender.bind(this, 'female')}
          label={'Weiblich'}
        />
      </div>
    );
  }
}

const styles = {
  container: {
  },
  button: {
    width: '50%',
  },
  female: {
    color: '#e170cb',
  },
  male: {
    color: '#23a0e8',
  },
  default: {
    color: 'black',
  },
};


export default GenderSelect;



// WEBPACK FOOTER //
// ./src/app/components/gender-select/gender-select.js